import { render, staticRenderFns } from "./TeamMemberRow.vue?vue&type=template&id=0c5ecaab&scoped=true"
import script from "./TeamMemberRow.vue?vue&type=script&lang=ts"
export * from "./TeamMemberRow.vue?vue&type=script&lang=ts"
import style0 from "./TeamMemberRow.vue?vue&type=style&index=0&id=0c5ecaab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5ecaab",
  null
  
)

export default component.exports